import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { formatDate } from "@ui-seeker/utils";
import { dataColors, dsColorNew } from "@palette";

export const CELL_MIN_WIDTH = 78
// Where a scrolled date label stops: just past the pinned site column
const AXIS_STICKY_LEFT = 280

// Three levels in one header cell: pickup date, its lengths of rental, and the acriss codes
// of each one. `AppBasicTable` paints a single header row, so the depth lives inside the cell.
export default function datesHeader(header, lors, acrissCodes) {

	return {
		setHeaderCellProps: () => ({
			sx: {
				p: 0,
				borderBottom: 0,
				minWidth: CELL_MIN_WIDTH * lors.length * acrissCodes.length,
				backgroundColor: dsColorNew.tableHead,
				// one date ends where the next begins: a date spans every LOR and acriss
				borderLeft: `2px solid ${alpha(dsColorNew.white, 0.18)}`,
			},
		}),
		render: () => <Box key={`${header}-${lors.join("-")}`} sx={{ backgroundColor: dsColorNew.tableHead }}>
			{/* 1 · the pickup date, as the other analyzers write it. It follows the scroll along its span, past the
			    pinned site column, so a wide date never scrolls by without its label */}
			<Box sx={{ px: 1.5, pt: 1, pb: 0.75, textAlign: 'left' }}>
				<Typography sx={{ position: 'sticky', left: AXIS_STICKY_LEFT, display: 'inline-block', fontSize: 13, fontWeight: 700, lineHeight: 1.3 }}>
					{formatDate(header, { isString: true, format: 'EEE dd MMM yyyy' })}
				</Typography>
			</Box>
			{/* 2 · each length of rental, named, with 3 · its acriss groups under it; a line between rentals */}
			<Grid container sx={{ backgroundColor: alpha(dsColorNew.white, 0.08), borderTop: `1px solid ${alpha(dsColorNew.white, 0.12)}` }}>
				{lors.map((lor, idx) => <Grid key={`${header}-${lor}-${idx}`} item xs={12 / lors.length}
					sx={{ py: 0.5, ...idx > 0 && { borderLeft: `1px solid ${alpha(dsColorNew.white, 0.15)}` } }}>
					<Typography sx={{ fontSize: 12, fontWeight: 600, textAlign: 'center', lineHeight: 1.4 }}>
						{lor} {Number(lor) === 1 ? 'day' : 'days'}
					</Typography>
					<Grid container sx={{ mt: 0.25 }}>
						{acrissCodes.map((acriss, acrissIdx) => <Grid
							key={`${header}-${lor}-${acriss}-${acrissIdx}`}
							item
							xs={12 / acrissCodes.length}
						>
							<Typography sx={{ display: 'block', textAlign: 'center', fontSize: 11, fontWeight: 400, color: dataColors.onNavyMuted, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', px: 0.25 }}>
								{acriss}
							</Typography>
						</Grid>)}
					</Grid>
				</Grid>)}
			</Grid>
		</Box>
	}
}
